// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"660b484a","141":"8e2424e1","327":"956858ce","400":"e1ae82e6","875":"a8473d2c"}[chunkId] + ".css";
};